import React from 'react';
import path from 'path';
import { promises as fs } from 'fs';
import { ResidencesList } from '../../components/Views/ResidencesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { residencesQuery } from '../../api/queries';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { ResidenceSort } from '../../graphql/types';
import { getSSRContextData } from '../../utils/helpers/ssrContext';

const Residences = props => <ResidencesList {...props} />;

export async function getServerSideProps({ res, req, query }) {
  const { platform } = getSSRContextData(req);

  const apolloClient = initApollo({}, { lang: getLocaleOnSSR(req), platform });
  const asPath = '/yasayis-kompleksleri';

  const sort = query.sort
    ? String(query.sort).toUpperCase()
    : ResidenceSort.DateDesc;

  if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
    const filePath = path.join(
      process.cwd(),
      'cypress/mock',
      'residencesMockData.json'
    );
    const file = await fs.readFile(filePath, 'utf-8');
    const mock = JSON.parse(file);

    return {
      props: { residences: mock.data.residences, hasError: false, sort }
    };
  }

  res.setHeader(
    'Cache-Control',
    'public, max-age=300, s-maxage=300, stale-while-revalidate=86400'
  );

  try {
    const [seoData, residencesRes, staticData] = await Promise.all([
      getSeoData(apolloClient, asPath, req, true),
      apolloClient.query({
        query: residencesQuery,
        variables: { sort }
      }),
      getStaticData(apolloClient)
    ]);

    return {
      props: {
        seoData,
        ...staticData,
        residences: residencesRes?.data?.residences || [],
        hasError: false,
        sort
      }
    };
  } catch {
    return {
      props: {
        seoData: {},
        keywords: [],
        citiesUnPopularList: [],
        regions: {},
        residences: [],
        hasError: true
      }
    };
  }
}

Residences.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation
    isShowCloseButton={false}
    pageProps={pageProps}
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default Residences;
